import {ApolloClient, concat, gql, InMemoryCache} from "@apollo/client";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import {ApolloProvider} from "@apollo/react-hooks";
import {Mutation} from "@apollo/client/react/components";
import {setContext} from "@apollo/client/link/context";
import {AUTH_TOKEN} from "../../constants";
import {Button} from "react-bootstrap";
import React, {useState} from "react";
import Avatar from "./Avatar";
import defaultPlate from './default_plate.jpeg';
import defaultMenu from './default_menu.jpeg';
import defaultAvatar from './default_avatar.png';

const authLink = setContext((_, {headers}) => {
  const token = localStorage.getItem(AUTH_TOKEN);
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  };
})

const uploadClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(authLink, createUploadLink({
    uri: `${process.env.REACT_APP_API_URL}/graphql`,
  }))
})

const UPLOAD_FILE = gql`
  mutation fileUpload($file: Upload!, $model: String!, $id: ID!, $field: String!) {
    fileUpload(input: {
      file: $file,
      model: $model,
      id: $id,
      field: $field
    }) {
      path
    }
  }
`;

function UploadFile({filePath, model, id, field, onChange}) {
  const inputFileRef = React.useRef();
  const [path, setPath] = useState(filePath)

  const onCompleted = (res) => {
    setPath(res.fileUpload.path)
    if (onChange) onChange(res.fileUpload)
  }

  const imgPath = () => {
    if (path) return path;
    if (model === 'menu') return defaultMenu;
    if (model === 'plate') return defaultPlate;
    return defaultAvatar;
  }

  return (
    <ApolloProvider client={uploadClient}>
      <div className='text-center'>
        <Avatar src={imgPath()} alt='image' style={{maxWidth: '150px', maxHeight: '150px', width: 'auto'}}/>
      </div>
      <div className="mt-2 mb-4 text-center">
        <div className="d-none">
          <Mutation mutation={UPLOAD_FILE} onCompleted={onCompleted} variables={{model, id, field}}>
            {(singleUpload, {data, loading}) => {
              return (<form onSubmit={() => {
              }} encType={'multipart/form-data'}>
                <input name='document'
                       ref={inputFileRef}
                       type='file' onChange={({target: {files}}) => {
                  const file = files[0]
                  file && singleUpload({variables: {file: file}})
                }}/>{loading && <p>Loading.....</p>}</form>)
            }
            }
          </Mutation>
        </div>
        <Button className='w-auto' onClick={() => {
          inputFileRef.current.click();
        }}>Modifica</Button>
      </div>
    </ApolloProvider>
  );
}

export default UploadFile